import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@orobix/orobix-fe-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { get } from '../../utils/api'
import { getQueryString } from '../../utils/queryString'
import { getObservationsQueryParams } from '../Observations/getObservationsQueryParams'
import { ObservationsParams, ObservationsResult } from '../Observations/types'
import useStyles from './SelectAllButton.styles'
import { Observation } from './types'

type SelectAllButtonProps = {
  selected: Observation[]
  setSelected: (selected: Observation[]) => void
  params: ObservationsParams
  disabled?: boolean
  showCount?: boolean
}

export const SelectAllButton = ({
  selected,
  setSelected,
  params,
  disabled = false,
  showCount = false,
}: SelectAllButtonProps) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const [isLoading, setLoading] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)

  const fetchMinimalObservations = () => {
    setLoading(true)
    return get<ObservationsResult>(
      `/observations/?${getQueryString({
        ...getObservationsQueryParams(params), // requires same params encoding as main /observations endpoint
        offset: 0,
        limit: 20000, // limit is required
        mode: 'no_image_data', // lightweight version of the response payload
      })}`
    )
      .then((response) => response?.results || [])
      .then(setSelected)
      .finally(() => setLoading(false))
  }

  const label = showCount
    ? t('Select all ({{count}})', { count: selected.length })
    : t('Select all')

  return (
    <div
      className={classes.wrapper}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <Button
        onClick={() => fetchMinimalObservations()}
        label={label}
        buttonType="button"
        type="default"
        loading={isLoading}
        disabled={disabled}
      />
      {showTooltip && (
        <div className={classes.tooltip}>
          <FontAwesomeIcon icon={faCircleInfo} />
          {t('Selection takes into account any applied filters')}
        </div>
      )}
    </div>
  )
}
